import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';
import Hero from '../Hero';
import Features from '../Features';
import HowItWorks from '../HowItWorks';
import KeyValues from '../KeyValues';
import UseCases from '../UseCases';
import ComparisonTable from '../ComparisonTable';
import EmailToolbar from '../EmailToolbar';
import Pricing from '../Pricing';
import Footer from '../Footer';
import Seo from '../Seo';
import { trackProductEvent } from '../../services/analytics';
import { getPostLoginDestination } from '../../services/postLoginRedirect';

const homepageStructuredData = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Uumail',
    url: 'https://uu.me/',
    logo: 'https://uu.me/uumail.png',
    sameAs: ['https://twitter.com/uumail', 'https://github.com/uumail'],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Uumail',
    applicationCategory: 'EmailApplication',
    operatingSystem: 'Web',
    url: 'https://uu.me/',
    description:
      'Create multiple private email addresses in seconds, forward messages to your real inbox, and manage every email alias from one dashboard.',
    offers: [
      {
        '@type': 'Offer',
        name: 'Free',
        price: '0',
        priceCurrency: 'USD',
      },
      {
        '@type': 'Offer',
        name: 'Plus',
        price: '3.99',
        priceCurrency: 'USD',
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What is Uumail?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Uumail is an email alias service that lets you create multiple private email addresses in seconds and forward messages to the inbox you already use.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do I need to create another mailbox?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'No. Uumail creates addresses that forward to your existing inbox, then lets you copy, search, disable, and manage them from one dashboard.',
        },
      },
    ],
  },
];

const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    trackProductEvent('landing_view', { source: 'landing_page' });
  }, []);

  useEffect(() => {
    const destination = getPostLoginDestination(window.location.search);
    if (destination) navigate(destination, { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Uumail | Email Alias Service for Private Email Addresses"
        description="Uumail is an email alias service for creating multiple private email addresses in seconds and forwarding them to your real inbox."
        path="/"
        structuredData={homepageStructuredData}
      />
      <Navbar />
      <Hero />
      <KeyValues />
      <HowItWorks />
      <Features />
      <UseCases />
      <ComparisonTable />
      <EmailToolbar />
      <Pricing />
      <Footer />
    </div>
  );
};

export default LandingPage;
